<template>
  <div class="box-root">
    <div class="box-header">{{ title }}</div>
    <div class="box-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String
  }
};
</script>

<style scoped>
.box-root {
  display: flex;
  flex-flow: column;
  box-shadow: 0 0 1px 1px rgba(222, 226, 222, 0.5);
}
.box-header {
  background-color: #f7f8f7;
  font-size: 1rem;
  padding: 10px;
  font-weight: bold;
  line-height: 1.1;
  text-transform: uppercase;
}
.box-content {
  padding: 10px;
}
@media all and (max-width: 640px) {
}
</style>
